import React from 'react';
import { Star } from 'lucide-react';
interface SocialProofProps {
  language: 'en' | 'es';
}
export function SocialProof({
  language
}: SocialProofProps) {
  const t = {
    en: {
      rentals: '500+ Rentals Completed'
    },
    es: {
      rentals: '500+ Rentas Completadas'
    }
  };
  const text = t[language];
  return <div className="w-full overflow-hidden bg-gold text-obsidian py-3 md:py-4 px-4 font-inter font-bold text-sm md:text-base" data-id="element-364">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-center items-center gap-2 md:gap-4 text-center" data-id="element-365">
        <span className="flex items-center justify-center gap-1" data-id="element-366">
          {[...Array(5)].map((_, i) => <Star key={i} size={18} fill="#0A0A0A" color="#0A0A0A" data-id="element-367" />)}
          <span className="ml-2" data-id="element-368">{text.rentals}</span>
        </span>

        <span className="hidden md:inline text-obsidian/30 text-lg" data-id="element-369">|</span>
        <div className="md:hidden w-[40%] border-t border-black/20 my-1" data-id="element-370"></div>

        <span data-id="element-371">Odessa • Midland • Andrews • Pecos • Fort Stockton</span>
      </div>
    </div>;
}